import ExportLinks from '@/models/ExportLinks';
import Vue from 'vue';
import translationsObj from '@/utils/translations/global';
const translations = translationsObj.data().translations;

function classNameToKey(className) {
  let name = className.replace(/Export$/, '');
  return name.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
}

const state = {
  exportsData: {}, // { [exportKey]: { status, file } }
};

const mutations = {
  resetState(state) {
    Object.assign(state, { exportsData: {} });
  },
  setExportStatus(state, { key, status }) {
    if (!state.exportsData[key]) {
      Vue.set(state.exportsData, key, {});
    }
    Vue.set(state.exportsData[key], 'status', status); // Make the property reactive

    // state.exportsData[key].status = status;
  },
  setExportFile(state, { key, file }) {
    if (!state.exportsData[key]) {
      Vue.set(state.exportsData, key, {});
    }
    Vue.set(state.exportsData[key], 'file', file);
  },
};

const actions = {
  async exportCSV({ commit, dispatch }, { key, query = '', filters = {} }) {
    try {
      commit('setExportStatus', { key, status: 2 }); // loading
      let exportFilters = {};
      for (const [k, v] of Object.entries(filters)) {
        if (v === null || v === undefined || v === '' || (Array.isArray(v) && v.length == 0))
          continue;
        if (Array.isArray(v)) exportFilters[k] = v.join(',');
        else exportFilters[k] = v;
      }
      await ExportLinks.exportFile(key, query, exportFilters);
    } catch (error) {
      console.error('Error exporting CSV:', error);
      dispatch(
        'newNotification',
        {
          type: 'error',
          message: error.response?.data?.message || 'Error exporting CSV',
          persistent: false,
        },
        { root: true }
      );
      commit('setExportStatus', { key, status: 1 }); // error
    }
  },
  async deleteCSV({ commit, state, dispatch }, key) {
    const file = state.exportsData[key]?.file;
    if (file?.user_store_export_id) {
      try {
        commit('setExportStatus', { key, status: 2 });
        await ExportLinks.deleteExportedFile(key, file.user_store_export_id);

        commit('setExportStatus', { key, status: 1 });
      } catch (e) {
        console.error('Error deleting export file:', e);
        dispatch(
          'newNotification',
          {
            type: 'error',
            message: e.response?.data?.message || 'Error deleting file',
            persistent: false,
          },
          { root: true }
        );
      }
    }
  },
  async fetchExportedFile({ commit, dispatch }, { key }) {
    try {
      const { data } = await ExportLinks.getExportedFile(key);
      commit('setExportFile', { key, file: data.data });
      await dispatch('handleExportStatus', { key });
    } catch (e) {
      commit('setExportStatus', { key, status: 1 });
      console.error(e);
      dispatch(
        'newNotification',
        {
          type: 'error',
          message: e.response?.data?.message || 'Error getting exported file',
          persistent: false,
        },
        { root: true }
      );
    }
  },

  handleExportStatus({ commit }, { key }) {
    let newStatus = 1;
    if (state.exportsData[key]?.file?.queue) newStatus = 2;
    else if (state.exportsData[key]?.file?.url) newStatus = 3;
    commit('setExportStatus', { key, status: newStatus });
  },

  handleExportEvent({ commit, dispatch, rootState }, data) {
    if (data.status === 'SUCCESS') {
      const key = classNameToKey(data.data.class_name);
      const lang = rootState.language || 'en';
      const fileName = key[0].toUpperCase() + key.slice(1).replace('-', ' ');

      data.url = data.data.url;
      data.urlText = translations.download[rootState.language] || 'download';
      data.message = translations.exportReady[lang](fileName);

      dispatch('fetchExportedFile', { key });
    }
    dispatch('newNotification', { ...data, persistent: true }, { root: true });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
